/**
 * CargaTransfolha
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaTransfolhaCollection} from '@/model/collection/CargaTransfolhaCollection'

/* TODO: review generated class */
export class CargaTransfolha extends Resource {
  idCargaTransfolhaPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  pedido: number | null = null

  lote: number | null = null
  lastIdCodigo: string | null = null
  dateLastEvent: string | null = null
  hourLastEvent: string | null = null
  lastDateTry: string | null = null

  get $id() {
    return this.idCargaTransfolhaPk
  }
  set $id(val) {
    this.idCargaTransfolhaPk = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaTransfolha
   */
  async getCargaTransfolha(id: number) {
    return await Request.get(`/admin/carga-transfolha/${id}`)
      .name('getCargaTransfolha')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaTransfolha
   */
  static async listCargaTransfolha(params: any) {
    return await Request.get(`/admin/carga-transfolha`, {params})
      .name('listCargaTransfolha')
      .as(CargaTransfolhaCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaTransfolha. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaTransfolha() {
    return await Request.post(`/admin/carga-transfolha`, this)
      .name('persistCargaTransfolha')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaTransfolha to use it in a CSV file
   */
  static async listCsvCargaTransfolha(params: any) {
    return await Request.get(`/admin/carga-transfolha/csv`, {params})
      .name('listCsvCargaTransfolha')
      .as(CargaTransfolhaCollection)
      .getData()
  }
}
